import { action, configure, decorate, observable, runInAction } from 'mobx';
import { error, fetchData, RootStore } from './RootStore';

configure({ enforceActions: 'observed' });

export type StepProps = {
  stepColor: string;
  stepCustomLine: { [key: string]: number[] } | null;
  stepId: string;
  stepName: string;
  stepParents: number[] | null;
  stepPath: string;
  stepPos: { x: number; y: number } | null;
  stepStraightLine: boolean | string;
  stepType: string;
};

export class StepsStore {
  rootStore: RootStore;
  steps: { [key: string]: StepProps[] | null };
  currentSteps: StepProps[] | null;
  isPending: boolean;
  error: error;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.steps = {};
    this.isPending = true;
    this.error = null;
    this.currentSteps = null;
  }

  getCurrentSteps = async (requestUrl: string) => {
    if (this.steps[requestUrl]) {
      this.currentSteps = this.steps[requestUrl];
      return;
    }

    this.isPending = true;
    this.currentSteps = null;
    this.error = null;

    try {
      const steps: StepProps[] | null = await fetchData(requestUrl);
      runInAction(() => {
        this.isPending = false;
        this.error = null;
        this.currentSteps = steps;
        this.steps = { ...this.steps, [requestUrl]: steps };
      });
    } catch (error) {
      runInAction(() => {
        this.currentSteps = null;
        this.error = { name: error.name, message: error.message };
        this.isPending = false;
      });
    }
  };

  findStep(id: string) {
    if (this.currentSteps && this.currentSteps.find(steps => steps.stepId === id) !== undefined) {
      return this.currentSteps.find(steps => steps.stepId === id) as StepProps;
    }
    return null;
  }

  getParents(id: string) {
    if (this.findStep(id)) {
      const step = this.findStep(id) as StepProps;
      const parents =
        step.stepParents &&
        step.stepParents.map((stepParentId: number) => this.findStep(String(stepParentId)));

      return parents;
    }
    return null;
  }

  getChildren(id: string): StepProps[] | null {
    return (
      this.currentSteps &&
      this.currentSteps.filter(
        steps => steps.stepParents && steps.stepParents.find(parentsId => String(parentsId) === id)
      )
    );
  }
}

decorate(StepsStore, {
  currentSteps: observable,
  error: observable,
  findStep: action,
  getChildren: action,
  getCurrentSteps: action,
  getParents: action,
  isPending: observable,
});
